import { PortfolioData } from '@/types/generated/common/account'

/**
 * A holding's average purchase price in USD, or undefined when the venue did
 * not send one.
 *
 * Only `exchange-toss` populates this today (`trade_venue/portfolio.rs`
 * `holding_row`) — crypto venues report a wallet balance, which has no purchase
 * price at all. The venue converts to USD itself, so the Entry column is always
 * in the same denomination as the Mark beside it.
 *
 * A non-positive or unparseable value is treated as absent: an Entry of 0 next
 * to a real Mark reads as a 100% gain rather than as missing data.
 */
export function avgPurchasePriceUsd(balance: PortfolioData): number | undefined {
  if (balance.averagePurchasePriceUsd === undefined) return undefined
  const parsed = Number(balance.averagePurchasePriceUsd)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined
}
